import React from 'react'
import moment from 'moment'

import {
    to12Hr
} from '../../../helpers/moment'

const ShiftReplacementRequest = ({ notification, schedule }) => {

    return (
        <div className="container">
            <div className="py-4 text-muted text-center" style={{ fontSize: '0.8rem' }}>{moment(notification.createdAt).fromNow()}, {to12Hr(moment(notification.createdAt))}</div>
            <h5>{notification.title}</h5>
            {
                (schedule && schedule.date) && (
                    <div>
                        A replacement is needed for a cancelled shift on {moment(schedule.date, 'YYYY-MM-DD').format('D MMMM YYYY')}, {schedule.shift.name} ({to12Hr(moment(schedule.shift.start_time, 'HH:mm:ss'))} - {to12Hr(moment(schedule.shift.end_time, 'HH:mm:ss'))})
                        <br />
                        <br />
                        If you are interested to take up this shift, please confirm.
                    </div>
                )
            }
            
        </div>
    )
}

export default ShiftReplacementRequest